import { createSlice } from '@reduxjs/toolkit';

// Slice
const initialForm = localStorage.getItem('form')
  ? JSON.parse(localStorage.getItem('form'))
  : null

const slice = createSlice({
  name: 'form',
  initialState: {
    form: initialForm,
  },
  reducers: {
    formSelected: (state, action) => {
      state.form = action.payload;
      localStorage.setItem('form', JSON.stringify(action.payload));
    },
    formReset: (state, action) =>  {
      state.form = null;
      localStorage.removeItem('form');
    },
  },
});

export default slice.reducer;

// Actions
const { formSelected, formReset } = slice.actions;

export const selectForm = (currentForm) => async dispatch => {
  try {
    dispatch(formSelected(currentForm));
  } catch (e) {
    return console.error(e.message);
  }
}

export const resetForm = () => async dispatch => {
  try {
    return dispatch(formReset())
  } catch (e) {
    return console.error(e.message);
  }
}
